const fetcher = (url, language) => {
  return fetch(`${url}?language=${language}`).then((res) =>
    res.json(),
  );
};

export default fetcher;
